'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var componentMap = {
  AB: _baseIcons.Headphones,
  ACCESSIBLE_FORMATS: _baseIcons.AccessibleFormat,
  AUDIOBOOKS_SPOKEN_WORD: _baseIcons.Headphones,
  BK: _baseIcons.Book,
  BLURAY: _baseIcons.CompactDisc,
  BOARD_BK: _baseIcons.Book,
  BOOK_CD: _baseIcons.Headphones,
  BOOK_PCD: _baseIcons.Book,
  BOOKS: _baseIcons.Book,
  CDROM: _baseIcons.CompactDisc,
  CS: _baseIcons.Headphones,
  DVD: _baseIcons.CompactDisc,
  EBOOK: _baseIcons.Device,
  DEVICE: _baseIcons.Device,
  FILM: _baseIcons.VideoCamera,
  GAMES_INTERACTIVE_MEDIA: _baseIcons.GameController,
  GRAPHIC_NOVEL: _baseIcons.Book,
  JOURNALS_MAGAZINES: _baseIcons.Newspaper,
  LPRINT: _baseIcons.AccessibleFormat,
  MN: _baseIcons.MusicalNote,
  MOVIES_TV_VIDEO: _baseIcons.VideoCamera,
  MP3_CD: _baseIcons.Headphones,
  MUSIC_CD: _baseIcons.MusicalNote,
  MUSIC_CS: _baseIcons.MusicalNote,
  MUSIC_MP3_CD: _baseIcons.MusicalNote,
  MUSIC_SOUND: _baseIcons.MusicalNote,
  MUSIC_DOWNLOAD: _baseIcons.MusicalNote,
  MUSIC_ONLINE: _baseIcons.MusicalNote,
  LP: _baseIcons.MusicalNote,
  NEWSPAPER: _baseIcons.Newspaper,
  MAG: _baseIcons.Newspaper,
  EJ: _baseIcons.Newspaper,
  OTHER: _baseIcons.Plus,
  PAPERBACK: _baseIcons.Book,
  PLAYAWAY_AUDIOBOOK: _baseIcons.Headphones,
  PLAYAWAY_MUSIC: _baseIcons.MusicalNote,
  VC: _baseIcons.VideoCamera,
  VIDEO_GAME: _baseIcons.GameController,
  VIDEO_ONLINE: _baseIcons.VideoCamera,
  BR: _baseIcons.AccessibleFormat,
  ATLAS: _baseIcons.Book,
  PASS: _baseIcons.Book,
  SPOKEN_CD: _baseIcons.Headphones,
  VIDEO_DOWNLOAD: _baseIcons.VideoCamera,
  _default: _baseIcons.Plus
};

var FormatIcon = function FormatIcon(_ref) {
  var _ref$format = _ref.format,
      format = _ref$format === undefined ? 'BK' : _ref$format,
      props = _objectWithoutProperties(_ref, ['format']);

  var ComponentName = componentMap[format] || componentMap._default;
  return _react2.default.createElement(ComponentName, _extends({ format: format }, props));
};

FormatIcon.propTypes = {
  format: _react.PropTypes.string.isRequired
};

exports.default = FormatIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-picker-token/lib/components/FormatIcon/FormatIcon.js
// module id = 873
// module chunks = 9 10